export const projects = [
  {
    id: "dark-factory",
    title: "Personal Software Dark Factory",
    description:
      "A personal software dark factory that automates the creation and upkeep of software using AI coding agents.",
    technologies: ["OpenRouter", "LLM APIs", "AI", "Docker", "Python"],
    weight: 0.9,
  },
  {
    id: "discord-bot",
    title: "Sports Discord Bot",
    description:
      "A Discord bot that enables team signups and weekly game coordination.",
    technologies: ["Docker", "Python", "MongoDB"],
    weight: 0.8,
  },
  {
    id: "website-creation-with-ai",
    title: "Website Creation With AI",
    description: "Creating custom websites using AI-powered tools",
    technologies: ["React", "AI", "Tailwind", "Vite", "Node.js"],
    weight: 0.9,
  },
  {
    id: "example-business-website",
    title: "Custom Business Website",
    description:
      "Creating custom website for a business using AI-powered tools",
    technologies: ["React", "AI", "Tailwind", "Vite"],
    weight: 0.9,
  },
  {
    id: "stock-analysis-website",
    title: "Stock Analysis Website",
    description:
      "Creating website that displays stock data with indicies and marker lines",
    technologies: ["React", "AI", "Vite", "Node.js"],
    weight: 0.9,
  },
  {
    id: "portfolio-website",
    title: "Portfolio Website",
    description:
      "This website is my portfolio website, it showcases my projects and skills",
    technologies: ["React", "AI", "Tailwind", "Vite", "Node.js"],
    weight: 0.9,
  },
  {
    id: "ata-project",
    title: "ATA Hackathon Project",
    description:
      "Developed a two-sided personnel application for airlines to track and communicate handicap equipment status to passengers",
    technologies: ["React", "C#"],
    weight: 0.7,
  },
  {
    id: "website-support-server",
    title: "Website Support Server",
    description: "Developed a node js server to support multiple websites",
    technologies: ["NodeJS", "AI"],
    weight: 0.7,
  },
];
